import { ApiService, UserProfileSettingsService } from '../../system-services';
import { ODataServiceBase } from './odata-base.service';
import { ODataSearch, ODataSearchResult } from './odata.models';

/**
 * Provides an implementation for transforming records of type U to type T
 */
export abstract class ODataTransformerBaseService<
    U,
    T
> extends ODataServiceBase<T> {
    constructor(api: ApiService, userProfile: UserProfileSettingsService) {
        super(api, userProfile);
    }

    /**
     * Gets the results of type U and transforms them to the output type of T
     *
     * @param search the search query
     * @param companyId the company id
     * @returns the search result set of type T
     */
    protected override async internalGetResults(
        search: ODataSearch,
        companyId: string
    ): Promise<ODataSearchResult<T>> {
        const [response] = await this.api.get<ODataSearchResult<U>>(
            `${this.buildODataUrl(companyId)}${this.buildODataQuery(search)}`
        );
        const transformedRecords = this.transform(response.records);
        return {
            totalRecords: response.totalRecords,
            recordsReturn: response.recordsReturn,
            records: transformedRecords
        };
    }

    /**
     * Transforms the provided input records of type U to the output type of T
     *
     * @param input the type returned from the API to be transformed to type T
     */
    protected abstract transform(input: U[]): T[];
}
